import { call, put, takeLatest } from "redux-saga/effects";

import { getAPIPayload } from "../../../../apis/getApi";
import { postAPIPayload } from "../../../../apis/postApi";
import { propertyRiskManagementAction } from "../../../slices/admin/property-risk-management/propertyRiskManagementSlice";

const withAuthenticatedRiskAssessmentAuth = (payload = {}) => {
  const url = String(payload?.url || "");
  const needsAuth =
    url.startsWith("admin/") || url.startsWith("service-provider/");
  return needsAuth ? { ...payload, token: true } : payload;
};

export function* fetchPropertyLoanAmountDataSaga({ payload }) {
  const response = yield call(
    postAPIPayload,
    withAuthenticatedRiskAssessmentAuth(payload),
  );
  yield put(propertyRiskManagementAction.fetchPropertyLoanAmountData(response));
}

export function* fetchRiskManagementDataSaga({ payload }) {
  const response = yield call(
    postAPIPayload,
    withAuthenticatedRiskAssessmentAuth(payload),
  );
  yield put(
    propertyRiskManagementAction.fetchPropertyRiskManagementData(response),
  );
}

export function* fetchCountyDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchCountyData(response));
}

export function* fetchSaveEmailSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchSaveEmailDetails(response));
}

export function* fetchSubscribeFreeMonitoringSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(
    propertyRiskManagementAction.fetchSubscribeFreeMonitoring(response)
  );
}

export function* fetchFreeMonitoringListSaga({ payload }) {
  console.log("In free Monitoring list sagas -->", payload);
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchFreeMonitoringList(response));
}

export function* fetchDeleteMonitoredPropertySaga({ payload }) {
  console.log("In free Monitoring list sagas -->", payload);
  const response = yield call(postAPIPayload, payload);
  yield put(
    propertyRiskManagementAction.fetchDeletedMonitoredPropertyData(response)
  );
}

export function* fetchResendReportMailSaga({ payload }) {
  console.log("In free Monitoring list sagas -->", payload);
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.getResendReportMailData(response));
}

export function* fetchInvestorReportResultDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(
    propertyRiskManagementAction.fetchInvestorReportResultData(response)
  );
}

export function* fetchInvestorMonitoringDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchInvestorMonitoringData(response));
}

export function* fetchInvestorPropertyMonitoringDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(
    propertyRiskManagementAction.fetchInvestorsPropertyServiceData(response)
  );
}

export function* fetchInvestorLoginDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchInvestorsLoginData(response));
}

export function* fetchInvestorBindEmailDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchInvestorsBindEmailData(response));
}

export function* fetchInvestorDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchInvestorsData(response));
}

export function* fetchInvestorsAddPropertyDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(
    propertyRiskManagementAction.fetchInvestorsAddPropertyData(response)
  );
}

export function* fetchSendWelcomeEmailDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchSendWelcomeEmailData(response));
}

export function* fetchBrokerListDataSaga({ payload }) {
  const response = yield call(getAPIPayload, payload);
  yield put(propertyRiskManagementAction.fetchBrokerListData(response));
}

export function* fetchTransferedPropertiesListDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(
    propertyRiskManagementAction.fetchTransferedPropertiesList(response)
  );
}

export function* fetchTransferedPropertyActionDataSaga({ payload }) {
  const response = yield call(postAPIPayload, payload);
  yield put(
    propertyRiskManagementAction.fetchTransferedPropertyActionData(response)
  );
}

export function* watchRiskManagementSagaAsync() {
  yield takeLatest(
    propertyRiskManagementAction.getPropertyLoanAmountData,
    fetchPropertyLoanAmountDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.propertyRiskManagementData,
    fetchRiskManagementDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.countyData,
    fetchCountyDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.saveEmailDetails,
    fetchSaveEmailSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.subscribeFreeMonitoring,
    fetchSubscribeFreeMonitoringSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.freeMonitoringList,
    fetchFreeMonitoringListSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.deleteMonitoredProperty,
    fetchDeleteMonitoredPropertySaga
  );
  yield takeLatest(
    propertyRiskManagementAction.fetchResendReportMailData,
    fetchResendReportMailSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getInvestorReportResultData,
    fetchInvestorReportResultDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getInvestorMonitoringData,
    fetchInvestorMonitoringDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getInvestorsPropertyServiceData,
    fetchInvestorPropertyMonitoringDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getInvestorsLoginData,
    fetchInvestorLoginDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getInvestorsBindEmailData,
    fetchInvestorBindEmailDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getInvestorsData,
    fetchInvestorDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getInvestorsAddPropertyData,
    fetchInvestorsAddPropertyDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getSendWelcomeEmailData,
    fetchSendWelcomeEmailDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getBrokerListData,
    fetchBrokerListDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getTransferedPropertiesList,
    fetchTransferedPropertiesListDataSaga
  );
  yield takeLatest(
    propertyRiskManagementAction.getTransferedPropertyActionData,
    fetchTransferedPropertyActionDataSaga
  );
}
